import { useEffect, useReducer, useMemo } from 'react';
import { useAppContext } from '../contexts/appContext';
import { AppEventType } from '../app/appEvents';
/**
 * Returns the current Organization from the App cache and re-reads
 * whenever an ORG_UPDATED event fires (e.g. subscription/usage change
 * via notification).
 */
export function useOrganization() {
    const { app } = useAppContext();
    const [tick, bump] = useReducer((x) => x + 1, 0);
    useEffect(() => {
        app.on(AppEventType.ORG_UPDATED, bump);
        return () => {
            app.off(AppEventType.ORG_UPDATED, bump);
        };
    }, [app]);
    return useMemo(() => app.getOrganization(), [app, tick]);
}
